import React from 'react'
import { encodeToUrlParams } from '../../../../lib/helpers'
import ArticleImageLink from '../../ArticleImageLink/ArticleImageLink'
import CategoryTag from '../../General/CategoryTag'
import { Link } from 'gatsby'

const SeasonTwoHighlightSection = ({data}) => {

    
    return (
        <div className='season-two-highlight-section'>
            <div className="season-two-intro">
                <h5 className='label'>{data.v2Season2IntroHeading?.v2Season2IntroHeading}</h5>
                <p>{data.v2Season2IntroDescription?.v2Season2IntroDescription}</p>
            </div>

            <div>

                <div className="highlight-section highlight-section-1">
                    <div className='copy-section'>
                        <h5 className='elizeth'>
                            {data.v2Season2BusinessHeading?.v2Season2BusinessHeading}
                        </h5>
                        <p>
                            {data.v2Season2BusinessDescription?.v2Season2BusinessDescription}
                        </p>

                        <div className="cta-links">
                            <Link to={`/articles/?${encodeToUrlParams(["Season 2", "Business"], "tags")}`}>
                                <CategoryTag>Explore</CategoryTag> 
                            </Link>
                            
                            <h6>
                                all <Link to={`/articles/?${encodeToUrlParams(["Season 2"], "tags")}`}>Season 2</Link> <Link to={`/articles/?${encodeToUrlParams(["Business"], "tags")}`}>Business</Link> articles.
                            </h6>
                        </div>
                    </div>      

                    <div className='link-container'>
                        <ArticleImageLink data={data.v2Season2HighlightBusiness[0]} textColor='white'/>
                    </div>
                </div>


                <div  className="highlight-section highlight-section-2">

                    <div className="copy-section">
                        <h5 className='elizeth'>
                            {data.v2Season2BeingHeading?.v2Season2BeingHeading}
                        </h5>

                        <p>
                            {data.v2Season2BeingDescription?.v2Season2BeingDescription}
                        </p>

                        <div className="cta-links">
                            <Link to={`/articles/?${encodeToUrlParams(["Season 2", "Being"], "tags")}`}>
                                <CategoryTag>Explore</CategoryTag> 
                            </Link>
                            <h6>
                                all <Link to={`/articles/?${encodeToUrlParams(["Season 2"], "tags")}`}>Season 2</Link> <Link to={`/articles/?${encodeToUrlParams(["Being"], "tags")}`}>Being</Link> articles.
                            </h6>
                        </div>
                    </div>

                    <div className='link-container sub-grid'>
                        <div className="sub-grid-item item-0">
                            <ArticleImageLink data={data.v2Season2HighlightBeing[0]} textColor='white'/>
                        </div>
                        <div className="sub-grid-item item-1">
                            <ArticleImageLink data={data.v2Season2HighlightBeing[1]} textColor='white'/>
                        </div>
                    </div>                    


                </div>

                <div className="highlight-section highlight-section-3">
                    <div className='copy'>
                        <h5 className='elizeth'>
                            {data.v2Season2BeyondHeading?.v2Season2BeyondHeading}
                        </h5>

                        <p>
                            {data.v2Season2BeyondDescription?.v2Season2BeyondDescription}
                        </p>

                        <div className="cta-links">
                            <Link to={`/articles/?${encodeToUrlParams(["Season 2", "Beyond"], "tags")}`}>
                                <CategoryTag>Explore</CategoryTag> 
                            </Link>
                            <h6>
                                all <Link to={`/articles/?${encodeToUrlParams(["Season 2"], "tags")}`}>Season 2</Link> <Link to={`/articles/?${encodeToUrlParams(["Beyond"], "tags")}`}>Beyond</Link> articles.
                            </h6>
                        </div>
                    </div>

                    <div className='link-container'>
                        <ArticleImageLink data={data.v2Season2HighlightBeyond[0]} textColor='white'/>
                    </div>

                </div>
            </div>

            <style jsx>{`   
                .season-two-highlight-section {
                    padding: 100px 60px;
                    background: linear-gradient(#80d5fc, #eaa7ff);
                }

                .season-two-intro {
                    text-align: center;
                    color: white;
                    margin-bottom: 120px;
                }

                .label {
                    font-size: 64px;
                    // font-weight: 400;
                    margin-bottom: 20px;
                    font-family: 'Elizeth';
                }

                .highlight-section {
                    min-height: 700px;
                    padding: 100px 0;
                }

                .highlight-section h5 {
                    color: white;
                    font-size: 60px;
                    margin-bottom: 30px;
                }

                .highlight-section p {
                    color: white;
                    font-size: 22px;
                    width: 500px;
                }

                .cta-links {
                    margin: 20px 0;
                    display: flex;
                    align-items: center;
                    color: white;
                }

                .cta-links h6 {
                    margin-left: 12px;
                    font-size: 22px;
                    font-weight: 400;
                }

                .highlight-section .cta-links :global(a) {
                    text-decoration: underline;
                    color: white;
                }

                .highlight-section :global(.title-container) {
                   padding: 12px;
                }

                .highlight-section :global(.article-title) {
                    font-size: 26px;
                }

                .highlight-section .sub-grid :global(.article-title) {
                    font-size: 18px;
                }

                .season-two-intro p {
                    font-size: 22px;
                    color: white;
                    width: 500px;
                    margin: 0 auto;
                }

                .link-container {
                    width: 100%;
                }


                .highlight-section-1 {
                    display: grid;
                    grid-template-columns: 7fr 5fr;
                    grid-gap: 60px;
                    justify-items: center;
                }
                .highlight-section-1 .copy-section {
                    padding-top: 150px;
                }

                .highlight-section-1 .link-container {
                    // margin-top: 200px;
                }

                .highlight-section-2 {
                    display: grid;
                    grid-template-columns: 1fr 1fr;
                    justify-items: center;
                }

                .highlight-section-2 .copy-section {
                    padding-top: 150px;
                }

                .sub-grid {
                    display: grid;
                    grid-template-columns: repeat(12, 1fr);
                }

                .sub-grid-item.item-0 {
                    grid-column: 7 / span 6;
                }
                .sub-grid-item.item-1 {
                    margin-top: 100px;
                    grid-column: span 7;
                }

                .highlight-section-3 {
                    display: grid;
                    grid-template-columns: 6fr 6fr;
                    grid-gap: 60px;
                    justify-items: center;
                }

                .highlight-section-3 .copy{
                    margin-top: 200px;
                }
                .highlight-section-3 .link-container {
                    padding: 40px;
                }

                @media (max-width: 1200px) {
                    .sub-grid-item.item-0 {
                        grid-column: 3 / span 10;
                    }

                    .sub-grid-item.item-1 {
                        grid-column: span 12;
                    }

                
                }



                @media (max-width: 1000px), (pointer: coarse) {
                    .season-two-highlight-section :global(.article-details) {
                        display: grid;
                    }
                    .season-two-intro {
                        margin-bottom: 40px;
                    }
                    
                    .season-two-intro p {
                        width: 100%;
                    }


                    .season-two-highlight-section {
                        padding: 100px 20px;
                    }

                    .label {
                        font-size: 56px;
                    }
                    .highlight-section {
                        padding: 40px 0;
                    }

                    .season-two-intro p, .cta-links h6{
                        font-size: 19px;
                    }

                    .highlight-section p {
                        width: 100%;
                        font-size: 19px;
                    }

                    .highlight-section h5 {
                        font-size: 34px;
                    }

                    .cta-links {
                        display: block;
                    }

                    .cta-links h6 {
                        margin-left: 0;
                    }

                    .season-two-highlight-section .cta-links :global(.category-tag) {
                        margin: 12px 0;
                    }

                    .highlight-section-1 {
                        display: block;
                    }

                    .highlight-section-1 .link-container, .sub-grid-item.item-0, .sub-grid-item.item-1, .highlight-section-3 .link-container {
                        margin-top: 80px;
                        
                    }

                    .highlight-section-1 .copy-section {
                        padding-top: 0;
                    }

                    .highlight-section-2 {
                        display: block;
                    }

                    .highlight-section-2 .copy-section {
                        padding-top: 0;
                    }

                    .sub-grid {
                        display: block;

                    }

                    .highlight-section-3 {
                        display: block;
\                   }
                    
                    .highlight-section-3 .copy {
                        margin-top: 0;
                    }

                    .highlight-section-3 .link-container {
                        padding: 0;
                    }

                }
            `}</style>
        </div>
    )
}

export default SeasonTwoHighlightSection